import { render, staticRenderFns } from "./AddHosting.vue?vue&type=template&id=08a1d72c&scoped=true"
import script from "./AddHosting.vue?vue&type=script&lang=js"
export * from "./AddHosting.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AddHosting.vue?vue&type=style&index=1&id=08a1d72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1d72c",
  null
  
)

export default component.exports